// extracted by mini-css-extract-plugin
module.exports = {"container":"DisplayImageManager_container__3HKPY","active":"DisplayImageManager_active__36m-a","table":"DisplayImageManager_table__3ITJJ"};